export default "__VITE_ASSET__DOT8gl_l__"